import { ForgotPasswordComponent } from "@forwardflow/components/ForgotPassword";

const ForgotPassword = () => {
  return <ForgotPasswordComponent />;
};

export default ForgotPassword;
